import React from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import { InfoCard } from '@backstage/core-components';
import { DashboardSnapshotList } from '@backstage-community/plugin-newrelic-dashboard';

const NEWRELIC_GUID_ANNOTATION = 'newrelic.com/dashboard-guid';

const NewRelicSnapshotCard = () => {
  const { entity } = useEntity();
  const guid = entity.metadata.annotations?.[NEWRELIC_GUID_ANNOTATION];

  if (!guid) {
    return null;
  }

  return (
    <InfoCard title="New Relic Dashboard" variant="gridItem">
      <DashboardSnapshotList guid={guid} />
    </InfoCard>
  );
};

export default NewRelicSnapshotCard;
